import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import LogoutIcon from "@mui/icons-material/Logout";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import SettingsIcon from "@mui/icons-material/Settings";
import { userLogOut } from "../../utils/utils";
import loginImage from "../../../resources/images/vyoog.png";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  ListItemIcon,
} from "@mui/material";

const TopMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [username, setUsername] = useState("");

  useEffect(() => {
    const storedUsername = localStorage.getItem("vyg_login_user");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  return (
    <Toolbar
      className="form-label"
      sx={{
        backgroundColor: "white",
        boxShadow: "0px 4px 10px white", // Add box-shadow
      }}
    >
      <Box sx={{ display: "flex", gap: 4, flexGrow: 1 }}>
        <img
          src={loginImage}
          alt="Login"
          style={{ width: "6%", marginTop: 10, marginBottom: "1rem" }}
        />
        <Button color="inherit" startIcon={<HomeIcon />}>
          Dashboard
        </Button>
        <Button color="inherit" startIcon={<InfoIcon />}>
          Item
        </Button>
        <Button color="inherit" startIcon={<ContactMailIcon />}>
          Order
        </Button>
        <Button color="inherit" startIcon={<SettingsIcon />}>
          Invoice
        </Button>
      </Box>

      {/* Right User Profile Menu */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body1" sx={{ marginRight: 2 }}>
          {username || "Guest"}
        </Typography>
        <Avatar
          alt={username}
          onClick={handleMenuClick}
          sx={{ cursor: "pointer" }}
        />
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openMenu}
          onClose={handleMenuClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              mt: 1.5,
              width: 200,
              "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem>
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
          <MenuItem onClick={() => userLogOut()}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Toolbar>
  );
};

export default TopMenu;
